import { render, staticRenderFns } from "./OportunityList.vue?vue&type=template&id=48c45878&lang=pug"
import script from "./OportunityList.vue?vue&type=script&lang=js"
export * from "./OportunityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48c45878')) {
      api.createRecord('48c45878', component.options)
    } else {
      api.reload('48c45878', component.options)
    }
    module.hot.accept("./OportunityList.vue?vue&type=template&id=48c45878&lang=pug", function () {
      api.rerender('48c45878', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/data_strategy/components/OportunityList.vue"
export default component.exports